<div class="bg--white">
  <scc-dsm3-nav-breadcrumbs [items$]="breadcrumbsItems$"></scc-dsm3-nav-breadcrumbs>
</div>

<section class="request__filter" *ngIf="authService.isAuthenticated()">
  <div class="container-fluid">
    <div class="row no-padding" *ngIf="showRetailerList()">
      <!-- FILTER COMMERCIAL -->
      <div class="btn-group pull-right">
        <div class="inline-block inline-block-middle select-wrapper">
          <label>
            <select
              class="form-control"
              (change)="changeRetailer()"
              id="retailerId"
              [(ngModel)]="selectRetailer"
              name="retailerId"
            >
              <option [ngValue]="'pt.edp.retailer.0'" selected class="placeholder">Seleccionar Comercializadora</option>
              <ng-container *ngFor="let list of retailersList">
                <option *ngIf="list.retailerUniqueCode !== 'pt.edp.retailer.0'" value="{{ list.retailerUniqueCode }}">
                  {{ list.retailerAlias }}
                </option>
              </ng-container>
            </select>
          </label>
        </div>
      </div>
    </div>
    <div class="row">
      <form [formGroup]="requestDateForm">
        <!-- DATEPICKER -->
        <div class="col-md-3" *ngIf="f.dateStart">
          <edpd-datepicker [placeholder]="'Desde data'" [mode]="'date'" formControlName="dateStart"></edpd-datepicker>
        </div>
        <div class="col-md-3" *ngIf="f.dateEnd">
          <edpd-datepicker [placeholder]="'Até data'" [mode]="'date'" formControlName="dateEnd"></edpd-datepicker>
        </div>
      </form>
      <div class="col-md-4">
        <div class="input-group search-box">
          <input
            class="form-control"
            placeholder="{{ searchPlaceholder }}"
            name="srch-term"
            id="srch-term"
            type="text"
            (ngModelChange)="onChangeSearch($event)"
            [(ngModel)]="searchTerm"
            (keydown.enter)="validationFilter()"
          />
          <div class="input-group-append input-group-btn">
            <button class="edp-btn btn-gray btn-icon" id="btn-srch-term" (click)="validationFilter()">
              <i class="fa fa-search"></i>
            </button>
          </div>
        </div>
      </div>
      <!-- EXPORT -->
      <div class="col-md-2 pull-right" *ngIf="tableData.length > 0">
        <button class="edp-btn btn-gray pull-right" (click)="export()">Exportar</button>
      </div>
    </div>
    <!-- DATES ERROR MESSAGES -->
    <div class="row" *ngIf="invalidDateInterval || invalidToBiggerThanFrom">
      <div class="col-md-12">
        <div class="alert alert-danger text-center" *ngIf="invalidDateInterval">O período de tempo é inválido.</div>
        <div class="alert alert-danger text-center" *ngIf="invalidToBiggerThanFrom">
          'Até data' não pode ser igual ou inferior à data 'Desde data'.
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <!-- TITLE -->
        <h1 color="black" class="inline">
          {{ requestTitle || 'Pedidos' | uppercase }}
        </h1>
        <!-- ASSIGN FILTER -->
        <div class="btn-group filter_assign" *ngIf="tableData.length > 0">
          <button
            class="btn dropdown-toggle link-font"
            type="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="true"
            *ngIf="!isRet"
            [disabled]="noneSelected"
          >
            <span class="">Atribuir a</span>
            <span class="chevron">
              <i class="fa fa-chevron-down"></i>
            </span>
          </button>
          <ul class="dropdown-menu">
            <li class="dropdown-search">
              <div class="input-group">
                <span class="input-group-addon" id="basic-addon1"><i class="fa fa-search"></i></span>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Pesquisa"
                  aria-describedby="basic-addon1"
                  [(ngModel)]="lookFor"
                />
              </div>
            </li>
            <li
              *ngFor="let item of assignableUsers | filterBy: ['userName'] : lookFor"
              (click)="assignRequests(item.userUniqueCode)"
              (keydown.enter)="assignRequests(item.userUniqueCode)"
              tabindex="0"
              class="cursor-pointer"
            >
              {{ item.userName }}
            </li>
            <hr />
            <li (click)="assignRequests()" (keydown.enter)="assignRequests()" tabindex="1" class="cursor-pointer">
              Remover Atribuição
            </li>
          </ul>
        </div>
        <!-- STATUS FILTER -->
        <!-- Remove function click outside dropdown to remove selecte items (openChange)="statusDropdownClick($event)" -->
        <div class="btn-group filter_status" #statusDropdown="ngbDropdown" ngbDropdown>
          <button
            class="btn dropdown-toggle link-font"
            type="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            ngbDropdownToggle
          >
            <span>Estado</span>
            <span
              *ngIf="countRequestStatusSelected > 0 && countRequestStatusSelected === requestStatusData.length"
              class="badge badge-primary"
              >Todos</span
            >
            <span
              *ngIf="countRequestStatusSelected > 0 && countRequestStatusSelected < requestStatusData.length"
              class="badge badge-primary"
              >{{ countRequestStatusSelected }}</span
            >
            <span class="chevron"><i class="fa fa-chevron-down"></i></span>
          </button>
          <ul class="dropdown-menu" ngbDropdownMenu>
            <li
              *ngFor="let item of requestStatusData; let i = index"
              [attr.data-index]="i"
              (click)="$event.stopPropagation()"
              (keydown)="($event.key === 'Enter' || $event.key === ' ') && $event.stopPropagation()"
              tabindex="0"
            >
              <label class="{{ item.requestStatusClass }}">
                <input
                  type="checkbox"
                  [checked]="item.requestStatusSelected"
                  (click)="toggleCheckRequestStatus(i)"
                  (keydown)="($event.key === 'Enter' || $event.key === ' ') && toggleCheckRequestStatus(i)"
                />
                <span></span>
                {{ item.requestStatusTitle }}
                <div class="ribbon"></div>
              </label>
            </li>
          </ul>
        </div>
        <!-- OPERATION TYPE FILTER -->
        <div class="btn-group filter_operation" *ngIf="!isRet">
          <button
            class="btn dropdown-toggle link-font"
            type="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="true"
          >
            <span>Pedido</span>
            <span *ngIf="requestOperationSelected" class="badge badge-primary">{{
              requestOperationTitleSelected
            }}</span>
            <span class="chevron">
              <i class="fa fa-chevron-down"></i>
            </span>
          </button>
          <ul class="dropdown-menu">
            <li
              (click)="$event.stopPropagation()"
              tabindex="0"
              (keydown)="($event.key === 'Enter' || $event.key === ' ') && $event.stopPropagation()"
            >
              <label>
                <input
                  type="radio"
                  name="optradiooperation"
                  [checked]="requestOperationCheckPo"
                  value="requestOperationTitleSelected"
                  (click)="itemRequestOperationSelected('po')"
                  (keydown)="($event.key === 'Enter' || $event.key === ' ') && itemRequestOperationSelected('po')"
                  tabindex="0"
                />
                <span></span>
                Pedido de operação
              </label>
            </li>
            <li
              (click)="$event.stopPropagation()"
              (keydown)="($event.key === 'Enter' || $event.key === ' ') && $event.stopPropagation()"
              tabindex="1"
            >
              <label>
                <input
                  type="radio"
                  name="optradiooperation"
                  [checked]="requestOperationCheckPe"
                  value="requestOperationTitleSelected"
                  (click)="itemRequestOperationSelected('pe')"
                  (keydown)="($event.key === 'Enter' || $event.key === ' ') && itemRequestOperationSelected('pe')"
                  tabindex="0"
                />
                <span></span>
                Pedido de esclarecimento
              </label>
            </li>
            <li class="btn-group pull-right">
              <button
                *ngIf="requestOperationSelected"
                class="edp-btn btn-gray btn-filter text-left"
                (click)="removeTypeFilter(requestOperationSelected)"
              >
                Remover
              </button>
            </li>
          </ul>
        </div>
        <!-- AREA FILTER -->
        <div class="btn-group filter_area" *ngIf="isRet || requestAreaData.length > 0">
          <button
            class="btn dropdown-toggle link-font"
            type="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="true"
          >
            <span>Área</span>
            <span *ngIf="requestAreaSelected" class="badge badge-primary">{{ requestAreaTitleSelected }}</span>
            <span class="chevron">
              <i class="fa fa-chevron-down"></i>
            </span>
          </button>
          <ul class="dropdown-menu">
            <li
              *ngFor="let item of requestAreaData; let i = index"
              [attr.data-index]="i"
              (click)="$event.stopPropagation()"
              tabindex="0"
              (keydown)="($event.key === 'Enter' || $event.key === ' ') && $event.stopPropagation()"
            >
              <label>
                <input
                  type="radio"
                  name="optradioarea"
                  [checked]="item.requestOperationSelected"
                  (click)="itemRequestAreaSelected(i)"
                  (keydown)="($event.key === 'Enter' || $event.key === ' ') && itemRequestAreaSelected(i)"
                  tabindex="0"
                />
                <span></span>
                {{ item.requestOperationTitle }}
              </label>
            </li>
            <li class="btn-group pull-right">
              <button
                *ngIf="requestAreaSelected"
                class="edp-btn btn-gray btn-filter text-left"
                (click)="removeTypeFilter(requestAreaSelected)"
              >
                Remover
              </button>
              <!-- <button class="edp-btn btn-gray btn-filter text-right" (click)="refreshData(0)">
                Filtrar
              </button> -->
            </li>
          </ul>
        </div>
        <!-- TYPE1 FILTER -->
        <div class="btn-group filter_type1" *ngIf="requestType1Data.length > 0">
          <button
            class="btn dropdown-toggle link-font"
            type="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="true"
          >
            <span>Tipo</span>
            <span *ngIf="requestType1Selected" class="badge badge-primary">{{ requestType1TitleSelected }}</span>
            <span class="chevron">
              <i class="fa fa-chevron-down"></i>
            </span>
          </button>
          <ul class="dropdown-menu">
            <li
              *ngFor="let item of requestType1Data; let i = index"
              [attr.data-index]="i"
              (click)="$event.stopPropagation()"
              tabindex="0"
              (keydown)="($event.key === 'Enter' || $event.key === ' ') && $event.stopPropagation()"
            >
              <label>
                <input
                  type="radio"
                  name="optradiotype1"
                  [checked]="item.requestOperationSelected"
                  (click)="itemRequestType1Selected(i)"
                  (keydown)="($event.key === 'Enter' || $event.key === ' ') && itemRequestType1Selected(i)"
                  tabindex="0"
                />
                <span></span>
                {{ item.requestOperationTitle }}
              </label>
            </li>
            <li class="btn-group pull-right">
              <button
                *ngIf="requestType1Selected"
                class="edp-btn btn-gray btn-filter text-left"
                (click)="removeTypeFilter(requestType1Selected)"
              >
                Remover
              </button>
              <!-- <button class="edp-btn btn-gray btn-filter text-right" (click)="refreshData(0)">
                Filtrar
              </button> -->
            </li>
          </ul>
        </div>
        <!-- TYPE2 FILTER -->
        <div class="btn-group filter_type2" *ngIf="requestType2Data.length > 0">
          <button
            class="btn dropdown-toggle link-font"
            type="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="true"
          >
            <span>Sub-Tipo</span>
            <span *ngIf="requestType2Selected" class="badge badge-primary">{{ requestType2TitleSelected }}</span>
            <span class="chevron">
              <i class="fa fa-chevron-down"></i>
            </span>
          </button>
          <ul class="dropdown-menu">
            <li
              *ngFor="let item of requestType2Data; let i = index"
              [attr.data-index]="i"
              (click)="$event.stopPropagation()"
              tabindex="0"
              (keydown)="($event.key === 'Enter' || $event.key === ' ') && $event.stopPropagation()"
            >
              <label>
                <input
                  type="radio"
                  name="optradiotype2"
                  [checked]="item.requestOperationSelected"
                  (click)="itemRequestType2Selected(i)"
                  (keydown)="($event.key === 'Enter' || $event.key === ' ') && itemRequestType2Selected(i)"
                  tabindex="0"
                />
                <span></span>
                {{ item.requestOperationTitle }}
              </label>
            </li>
            <li class="btn-group pull-right">
              <button
                *ngIf="requestType2Selected"
                class="edp-btn btn-gray btn-filter text-left"
                (click)="removeTypeFilter(requestType2Selected)"
              >
                Remover
              </button>
              <!-- <button class="edp-btn btn-gray btn-filter text-right" (click)="refreshData(0)">
                Filtrar
              </button> -->
            </li>
          </ul>
        </div>
        <!-- FILTER ACTION BUTTONS -->
        <div class="pull-right">
          <button class="edp-btn btn-yellow" [disabled]="!filtersCtrl" (click)="validationFilter()">
            Aplicar Filtros
          </button>
          <button class="edp-btn btn-gray" [disabled]="!showSessionFilters" (click)="resetFilters()">
            Remover Filtros
          </button>
        </div>
      </div>
      <!-- <div class="col-md-2" *ngIf="showSessionFilters">
        <button
          class="edp-btn btn-yellow pull-right"
          (click)="resetSessionFilters()"
        >
          Limpar Filtros
        </button>
      </div> -->
    </div>
    <div class="row">
      <!-- PAGINATION -->
      <div class="col-md-12 text-right" *ngIf="tableData.length > 0">
        {{ skip + 1 }}-{{ skip + tableData.length }} de {{ totalItems }}
        <button
          class="edp-btn btn-gray btn-icon"
          [disabled]="isFirstPage() || tableData.length === 0"
          (click)="previousPage()"
        >
          <i class="glyphicon glyphicon-chevron-left"></i>
        </button>
        <button
          class="edp-btn btn-gray btn-icon"
          [disabled]="isLastPage() || tableData.length === 0"
          (click)="nextPage()"
        >
          <i class="glyphicon glyphicon-chevron-right"></i>
        </button>
        <button class="edp-btn btn-gray" *ngIf="showingLess" (click)="seeMoreResults()" [disabled]="checkDisabled()">
          Ver mais
        </button>
        <button class="edp-btn btn-gray" *ngIf="!showingLess" (click)="seeLessResults()">Ver menos</button>
      </div>
    </div>
  </div>
</section>

<section class="request__content" *ngIf="authService.isAuthenticated()">
  <div class="container-fluid">
    <div class="row no-padding">
      <div class="col-md-2" *ngIf="!isRet">
        <app-tree [directories]="menuList" (choice)="setFolder($event)"></app-tree>
      </div>
      <div [ngClass]="isRet ? 'col-md-12' : 'col-md-10'">
        <table class="table" *ngIf="tableData.length > 0; else elseBlock">
          <thead>
            <tr>
              <th>
                <a
                  [class.asc]="order === 'statusTitle' && direction === 'ASC'"
                  [class.desc]="order === 'statusTitle' && direction === 'DESC'"
                  (click)="refreshData(0, 'statusTitle')"
                  (keydown.enter)="refreshData(0, 'statusTitle')"
                  tabindex="0"
                  role="button"
                >
                  Estado
                  <i class="fa fa-sort-asc" aria-hidden="true"></i>
                  <i class="fa fa-sort-desc" aria-hidden="true"></i>
                </a>
              </th>
              <th *ngIf="!isRet">
                <a
                  [class.asc]="order === 'retailerName' && direction === 'ASC'"
                  [class.desc]="order === 'retailerName' && direction === 'DESC'"
                  (click)="refreshData(0, 'retailerName')"
                  (keydown.enter)="refreshData(0, 'retailerName')"
                  tabindex="1"
                  role="button"
                >
                  Comercializadora
                  <i class="fa fa-sort-asc" aria-hidden="true"></i>
                  <i class="fa fa-sort-desc" aria-hidden="true"></i>
                </a>
              </th>
              <th>
                <a
                  [class.asc]="order === 'requestMainId' && direction === 'ASC'"
                  [class.desc]="order === 'requestMainId' && direction === 'DESC'"
                  (click)="refreshData(0, 'requestMainId')"
                  (keydown.enter)="refreshData(0, 'requestMainId')"
                  tabindex="2"
                  role="button"
                >
                  ID
                  <i class="fa fa-sort-asc" aria-hidden="true"></i>
                  <i class="fa fa-sort-desc" aria-hidden="true"></i>
                </a>
              </th>
              <th>
                <a
                  [class.asc]="order === 'fieldCpe' && direction === 'ASC'"
                  [class.desc]="order === 'fieldCpe' && direction === 'DESC'"
                  (click)="refreshData(0, 'fieldCpe')"
                  (keydown.enter)="refreshData(0, 'fieldCpe')"
                  tabindex="3"
                  role="button"
                >
                  CPE
                  <i class="fa fa-sort-asc" aria-hidden="true"></i>
                  <i class="fa fa-sort-desc" aria-hidden="true"></i>
                </a>
              </th>
              <th>
                <a
                  [class.asc]="order === 'requestTypeName' && direction === 'ASC'"
                  [class.desc]="order === 'requestTypeName' && direction === 'DESC'"
                  (click)="refreshData(0, 'requestTypeName')"
                  (keydown.enter)="refreshData(0, 'requestTypeName')"
                  tabindex="4"
                  role="button"
                >
                  Tipo
                  <i class="fa fa-sort-asc" aria-hidden="true"></i>
                  <i class="fa fa-sort-desc" aria-hidden="true"></i>
                </a>
              </th>
              <th>
                <a
                  [class.asc]="order === 'requestSubTypeName' && direction === 'ASC'"
                  [class.desc]="order === 'requestSubTypeName' && direction === 'DESC'"
                  (click)="refreshData(0, 'requestSubTypeName')"
                  (keydown.enter)="refreshData(0, 'requestSubTypeName')"
                  tabindex="5"
                  role="button"
                >
                  Sub-tipo
                  <i class="fa fa-sort-asc" aria-hidden="true"></i>
                  <i class="fa fa-sort-desc" aria-hidden="true"></i>
                </a>
              </th>
              <th *ngIf="isRet">
                <a
                  [class.asc]="order === 'createdBy' && direction === 'ASC'"
                  [class.desc]="order === 'createdBy' && direction === 'DESC'"
                  (click)="refreshData(0, 'createdBy')"
                  (keydown.enter)="refreshData(0, 'createdBy')"
                  tabindex="6"
                  role="button"
                >
                  Criado por
                  <i class="fa fa-sort-asc" aria-hidden="true"></i>
                  <i class="fa fa-sort-desc" aria-hidden="true"></i>
                </a>
              </th>
              <th>
                <a
                  [class.asc]="order === 'createdAt' && direction === 'ASC'"
                  [class.desc]="order === 'createdAt' && direction === 'DESC'"
                  (click)="refreshData(0, 'createdAt')"
                  (keydown.enter)="refreshData(0, 'createdAt')"
                  tabindex="7"
                  role="button"
                >
                  Data de criação
                  <i class="fa fa-sort-asc" aria-hidden="true"></i>
                  <i class="fa fa-sort-desc" aria-hidden="true"></i>
                </a>
              </th>
              <th *ngIf="!isRet">
                <a
                  [class.asc]="order === 'assigneeName' && direction === 'ASC'"
                  class="pointer-event"
                  [class.desc]="order === 'assigneeName' && direction === 'DESC'"
                  (click)="refreshData(0, 'assigneeName')"
                  (keydown.enter)="refreshData(0, 'assigneeName')"
                  tabindex="8"
                  role="button"
                >
                  Atribuído a
                  <i class="fa fa-sort-asc" aria-hidden="true"></i>
                  <i class="fa fa-sort-desc" aria-hidden="true"></i>
                </a>
              </th>
              <th *ngIf="!isRet" class="check">
                <label>
                  <input type="checkbox" name="check" (change)="toggleCheckAll($event)" />
                  <span></span>
                </label>
              </th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <!-- CREATE OPERATION REQUEST -->
            <tr class="create" *appRequestPermission="rPermission" (click)="openNewOperationRequest()">
              <td colspan="8"><i class="icon-plus" aria-hidden="true"></i> Criar Pedido de {{ requestTitle }}</td>
            </tr>
            <tr *ngFor="let item of tableData; let i = index" class="{{ item.statusClass }}">
              <td class="state">
                {{ item.statusTitle || '-' }}
                <i class="fa fa-exclamation-triangle hidden" color="black"></i>
              </td>
              <td *ngIf="!isRet">{{ item.retailerName || '-' }}</td>
              <td>{{ item.requestMainId || '-' }}</td>
              <td>{{ item.requestCpe || '-' }}</td>
              <td>{{ item.requestType || '-' }}</td>
              <td>{{ item.requestSubType || '-' }}</td>
              <td *ngIf="isRet">{{ item.createdBy || '-' }}</td>
              <td>
                {{ item.createdAt | amFromUtc | amLocal | amDateFormat: 'DD/MM/YYYY' || '-' }}
              </td>
              <td *ngIf="!isRet">{{ item.assignedUserName || '-' }}</td>
              <td *ngIf="!isRet" class="check middle">
                <label *ngIf="showCheck(item)">
                  <input type="checkbox" name="check" [checked]="item.itemSelected" (click)="toggleCheck(i)" />
                  <span></span>
                </label>
              </td>
              <td class="middle cursor-pointer" (click)="openRequestDetail(item.requestUniqueCode)">
                <i color="black" class="glyphicon glyphicon-chevron-right cursor-pointer"></i>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <ng-template #elseBlock>
        <table class="table table-create table-center">
          <thead>
            <tr>
              <th scope="col" style="padding: 0"></th>
            </tr>
            <tr>
              <th scope="col" style="padding: 0"></th>
            </tr>
          </thead>
          <tbody>
            <!-- CREATE OPERATION REQUEST -->
            <tr class="create" *appRequestPermission="rPermission" (click)="openNewOperationRequest()">
              <td colspan="8"><i class="icon-plus" aria-hidden="true"></i> Criar Pedido de {{ requestTitle }}</td>
            </tr>
            <tr *ngIf="tableData.length === 0 && isEmptyList && isRet">
              <td>
                <p>De momento não existem registos.</p>
              </td>
            </tr>
            <tr *ngIf="tableData.length === 0 && isEmptyList && !isRet">
              <td>
                <p>De momento não existem registos para esta equipa.</p>
              </td>
            </tr>
            <tr *ngIf="tableData.length === 0 && !isEmptyList && !isRet">
              <td>
                <p>Selecione uma equipa para ver os respetivos pedidos</p>
              </td>
            </tr>
          </tbody>
        </table>
      </ng-template>
    </div>
  </div>
</section>
